import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import type { BrowserOptions } from '@sentry/react';
import LandingPage from '@/pages/Landing.tsx';
import FinishPage from '@/pages/Finish.tsx';
import './styles/global.css';
import './i18n/config.ts';

const sentryOptions: BrowserOptions = {
  dsn: import.meta.env.VITE_SENTRY_DNS,
  integrations: [Sentry.browserTracingIntegration()],
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  environment: 'production',
  enabled: !!import.meta.env.VITE_SENTRY_DNS,
};

Sentry.init(sentryOptions);

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPage />,
  },
  {
    path: '/finish',
    element: <FinishPage />,
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
